import axios from 'axios'
import { CATALOGO_ENDPOINT } from '../../endpoints'

export async function getMassiveUploadSchema() {
  const response = await axios.get(`${CATALOGO_ENDPOINT}/massiveUploadSchema`)
  return response?.data
}
